import serialize from "store/serialize"
import * as types from "types/actions/screen"

export const initScreen = () => ({
  type: types.SCREEN_INIT
})

export const clearScreen = () => ({
  type: types.SCREEN_TEMPLATE_CLEAR
})

export const setScreenColor = color => ({
  type: types.SCREEN_COLOR_SET,
  color
})

export const updateScreen = screen => ({
  type: types.SCREEN_UPDATE,
  screen
})

export const setTemplate = data => {
  return dispatch => {
    return serialize("template", data).then(template => {
      dispatch({
        type: types.SCREEN_TEMPLATE_SET,
        template
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/screen.js